import { useState } from "react";
import { colorOptions } from "../../../../constants/constants";
import NotificationPanel from "../../action-center/notification-panel/NotificationPanel";
import Display from "../display/Display";
import Styles from "./Themes.module.scss";
import classnames from "classnames"
import Switch from "../../../switch/Switch";

const Themes = () => {

    const handleAccentColor = (colorValue: any) => {
        document.documentElement.style.setProperty(('--skin-color'), `rgb(${colorValue})`)
        document.documentElement.style.setProperty(('--skin-c'), colorValue)
        setColor(colorValue)
    }

    const [activeColor, setColor] = useState(document.documentElement.style.getPropertyValue(('--skin-c')) || colorOptions[0].color)

    const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains("dark"))

    const handleThemeClick = () => {
        document.body.classList.toggle("dark");
        setIsDarkMode(!isDarkMode)
    }


    return (
        <div className={Styles.container}>
            <div className={classnames(Styles.screens_container)}>
                <div className={Styles.screen}>
                    <NotificationPanel customClass={classnames(Styles.actual_screen, Styles.notification_bar)} />
                </div>
                <div className={Styles.screen}>
                    <Display customClass={Styles.actual_screen} />
                </div>
                <div className={Styles.screen_disabler} />
            </div>

            <div className={classnames(Styles.color_container, "solid_bg")}>
                <div className={Styles.title}>
                    Colour Palette
                </div>
                <div className={Styles.colors}>
                    {colorOptions.map((color) => {
                        return (
                            <div className={Styles.color} key={color.id || color.color} >
                                <div className={classnames(Styles.color_option, activeColor===color.color && Styles.active)} style={{ backgroundColor: `rgb(${color.color})` }} onClick={() => { handleAccentColor(color.color) }} />
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className={classnames(Styles.option,"solid_bg")}>
                    Dark Mode
                    <Switch isChecked={isDarkMode} onClick={handleThemeClick}/>
            </div>
        </div>
    )
}

export default Themes
